import React from "react";

export function PhotoSvg({
                             width = "100%",
                             height = "100%",
                             bg = "#F1F5F9",
                             icon = "#94A3B8",
                             ...props
                         }) {
    return (
        <svg
            viewBox="0 0 300 300"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <defs>
                <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#F8FAFC"/>
                    <stop offset="100%" stopColor="#EEF2F7"/>
                </linearGradient>
            </defs>

            {/* Background */}
            <rect width="300" height="300" rx="24" fill="url(#bg)"/>

            {/* Soft image icon */}
            <g opacity="0.45">
                <rect
                    x="85"
                    y="95"
                    width="130"
                    height="100"
                    rx="14"
                    fill="#CBD5E1"
                />

                <circle cx="120" cy="125" r="8" fill="#F8FAFC"/>

                <path
                    d="M95 180l35-35 28 28 32-32 25 39H95z"
                    fill="#F8FAFC"
                />
            </g>
        </svg>
    );
}

export function ImagePlaceholder({
                                     ...props
                                 }) {
    return (
        <div style={{aspectRatio: "1 / 1", width: "100%"}}>
            <PhotoSvg/>
        </div>
    );
}

// SVG data-URI dùng cho prop `fallback` của antd Image (rc-image chỉ nhận string, không nhận ReactNode
// như `placeholder`). Icon bên trong là glyph của react-icons/hi2 HiOutlinePhoto, phóng to hơn một chút
// so với icon mặc định của PhotoSvg và giữ cùng nền/màu để đồng bộ.
const PHOTO_FALLBACK_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
    <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#F8FAFC"/>
            <stop offset="100%" stop-color="#EEF2F7"/>
        </linearGradient>
    </defs>
    <rect width="300" height="300" rx="24" fill="url(#bg)"/>
    <g transform="translate(75,75) scale(6.25)" fill="none" stroke="#94A3B8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
    </g>
</svg>
`

export const PhotoFallbackIcon = `data:image/svg+xml,${encodeURIComponent(PHOTO_FALLBACK_SVG)}`

export default PhotoSvg
